import {Component, computed, inject, input} from '@angular/core';
import {
  ArrowRightFromLineIcon,
  ArrowRightToLineIcon,
  Calendar1Icon,
  CalendarClockIcon,
  CalendarSyncIcon,
  ClockFadingIcon,
  LucideAngularModule,
  TriangleAlertIcon
} from 'lucide-angular';
import {RecurringUnit} from '@domain/common/common';
import {TimeUtil} from '@shared/util/time.util';
import {ActivityScheduleDTO} from '@domain/activity/schedule/schedule.dto';
import {WeekdayPipe} from '@domain/common/pipe/weekday.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';

@Component({
  selector: 'app-schedule-time',
  imports: [
    LucideAngularModule
  ],
  providers: [
    WeekdayPipe
  ],
  templateUrl: './schedule-time.component.html'
})
export class ScheduleTimeComponent {

  public readonly activity = input.required<ActivityDTO>();
  public readonly schedule = input.required<ActivityScheduleDTO>();

  private readonly weekdayPipe = inject(WeekdayPipe);

  public readonly icons = {
    time: CalendarClockIcon,
    time1: Calendar1Icon,
    timeRepeat: CalendarSyncIcon,
    since: ArrowRightFromLineIcon,
    until: ArrowRightToLineIcon,
    sporadicSchedule: ClockFadingIcon,
    warn: TriangleAlertIcon
  };

  public readonly icon = computed(() => {
    switch (this.schedule()?.recurringUnit) {
      case RecurringUnit.Sporadic:
        return this.icons.sporadicSchedule;
      case null:
        return this.icons.sporadicSchedule;
      case RecurringUnit.Week:
        return this.icons.timeRepeat;
      case RecurringUnit.OneOff:
        return this.icons.time1;
    }
    return null;
  });

  public readonly text = computed(() => {
    const schedule = this.schedule();
    const recurringUnit = schedule?.recurringUnit;
    if (recurringUnit === RecurringUnit.Sporadic || recurringUnit === null) {
      return 'Horaires sur demande';
    }
    const dayAbbrev = this.weekdayPipe.transform(schedule?.startDay, true)?.toUpperCase();
    if (!dayAbbrev) {
      return null;
    }
    let str = `${dayAbbrev}${recurringUnit === RecurringUnit.OneOff && schedule?.validFrom? ` ${TimeUtil.formatDate(schedule.validFrom)}` : ''}`;

    if (schedule?.startTime) {
      str += ` à ${TimeUtil.formatTime(schedule.startTime)}`;
    }
    return str;
  });

}
